import angular from 'angular'

import { trim, isNotEmpty, isAllDefined } from '../utils/bits'
import { flow, camelCase, upperFirst, toPairs, isPlainObject } from 'lodash-es'

const capitalCase = flow(camelCase, upperFirst)

import setCss from '../utils/set-css'
import extractRawElm from '../utils/extract-raw-elm'

// reg dirs
const STYLE_ATTR = 'style'
const MODULE_NAME = 'ggs.attr'
const BASE_DIRECTIVE_NAME = 'ggs'

angular
  .module(MODULE_NAME)
  .directive('ggsAttr', AttrDirective)

registerDirective('id', generalAttrApply)
registerDirective('src', generalAttrApply)
registerDirective('href', generalAttrApply)
registerDirective('style', styleAttrApply)

function registerDirective(attrName, attrApply) {
  const directiveName = BASE_DIRECTIVE_NAME + capitalCase(attrName)
  const directiveProvider = makeDirective(directiveName, attrName, attrApply)
  return angular
    .module(MODULE_NAME)
    .directive(directiveName, directiveProvider)
}

// main
function AttrDirective($parse) {
  return {
    restrict: 'A',
    link: realLink
  }

  function realLink($scope, $elm, $attr) {
    const elm = extractRawElm($elm)
    const ngExp = $parse($attr.ggsAttr)
    const init = ngExp($scope)

    if (isAllDefined(init) && ngExp.oneTime) {
      applyAttrGeneral(init)
    } else {
      $scope.$watch(ngExp, applyAttrGeneral)
    }

    function applyAttrGeneral(attrObj) {
      for (const [attrKey, attrVal]  of toPairs(attrObj)) {
        attrKey === STYLE_ATTR
          ? styleAttrApply(elm, attrKey, attrVal)
          : generalAttrApply(elm, attrKey, attrVal)
      }
    }
  }
}

function makeDirective(directiveName, attrName, attrApply) {
  return function directiveProvider($parse) {
    'ngInject'

    return {
      restrict: 'A',
      link: realLink
    }

    function realLink($scope, $elm, $attr) {
      const elm = extractRawElm($elm)
      const ngExp = $parse($attr[directiveName])
      const init = ngExp($scope)

      if (isAllDefined(init) && ngExp.oneTime) {
        localAttrApply(init)
      } else {
        $scope.$watch(ngExp, localAttrApply)
      }

      function localAttrApply(attrVal) {
        attrApply(elm, attrName, attrVal)
      }
    }
  }
}

// helpers
function generalAttrApply(elm, attrName, attrVal) {
  isNotEmpty(attrVal)
    ? elm.setAttribute(attrName, attrVal)
    : elm.removeAttribute(attrName)
}

function styleAttrApply(elm, _attrName, attrVal) {
  setCss(elm, formatStyle(attrVal))
}

function formatStyle(style) {
  if (isPlainObject(style)) {
    return style
  }

  const pairs = style.split(';').map(trim).filter(isNotEmpty)
  const object = {}
  for (const pair of pairs) {
    const arr = pair.split(':').map(trim)
    const key = arr[0]
    const val = arr[1]
    object[key] = val
  }
  return object
}
